export enum PublicationType {
    None = 0,
    Document = 1,
    Spreadsheet = 2,
    Presentation = 3,
    Pdf = 4,
    Image = 5,
    Archive = 6,
}
